// extracted by mini-css-extract-plugin
module.exports = {"slide":"slide-1tuAOLEa","slideBox":"slideBox-3I_mbWxk"};